import React, { useEffect, useState } from 'react'
import { Strong } from 'src/components/text/strong'
import { useApiClient } from 'src/integrations/stock-reports-client/context'

interface Props {
  id: string
  name: string
  generatedAt: string
  lastClose: string
  marketCap: string
}

export const CurrentPriceFAQItem: React.FC<Props> = ({
  id,
  name,
  generatedAt,
  marketCap,
  lastClose,
}) => {
  const [lastUpdate, setLastUpdate] = useState(generatedAt)
  const [tradingAt, setTradingAt] = useState(lastClose)
  const apiClient = useApiClient()

  useEffect(() => {
    apiClient.getQuote(id).then(({ data }) => {
      setLastUpdate(data.lastTrade)
      setTradingAt(data.price)
    })
  }, [apiClient])

  return (
    <p>
      As of {lastUpdate}, shares in {name} are trading at&nbsp;
      <Strong>{tradingAt}</Strong>. This share price information is delayed by
      15 minutes.
    </p>
  )
}
